// eslint-disable-next-line no-restricted-imports
import type { ResponsiveObject } from "@chakra-ui/react";

export type GalleryLayoutConfig = {
    grid: {
        rowSpan: ResponsiveObject<number>;
        colSpan: ResponsiveObject<number>;
        rowStart?: ResponsiveObject<number>;
        colStart?: ResponsiveObject<number>;
    };
    gridItem: {
        aspectRatio: ResponsiveObject<string>;
        fillVertical?: boolean;
    };
    gridItemAsset: {
        aspectRatio: ResponsiveObject<string>;
        sizes: Array<string>;
    };
};

const gridWith5Items: Array<GalleryLayoutConfig> = [
    {
        grid: {
            colSpan: { base: 12, s: 4 },
            rowSpan: { base: 2, s: 5 },
        },
        gridItem: {
            aspectRatio: { base: "5:4", xs: "5:4", s: "3:5" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1", xs: "1:1", s: "9:16" },
            sizes: ["100vw", "100vw", "33vw"],
        },
    },
    {
        grid: { colSpan: { base: 6, s: 4 }, rowSpan: { base: 1, s: 3 } },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["50vw", "50vw", "33vw"],
        },
    },
    {
        grid: { colSpan: { base: 6, s: 4 }, rowSpan: { base: 1, s: 3 } },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["50vw", "50vw", "33vw"],
        },
    },
    {
        grid: {
            colSpan: { base: 12, s: 4 },
            rowSpan: { base: 3, s: 3 },
            colStart: { s: 1 },
            rowStart: { s: 6 },
        },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["100vw", "100vw", "33vw"],
        },
    },
    {
        grid: {
            colSpan: { base: 12, s: 8 },
            rowSpan: { base: 5, s: 5 },
        },
        gridItem: {
            aspectRatio: { base: "4:5", xs: "4:5", s: "5:4" },
            fillVertical: true,
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["100vw", "100vw", "75vw"],
        },
    },
];

const gridWith4Items = [
    {
        grid: { colSpan: { base: 6, s: 8 }, rowSpan: { base: 2, s: 6 } },
        gridItem: {
            aspectRatio: { base: "1:1", xs: "1:1", s: "16:9" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1", xs: "1:1", s: "16:9" },
            sizes: ["100vw", "100vw", "66vw"],
        },
    },
    {
        grid: { colSpan: { base: 6, s: 4 }, rowSpan: { base: 2, s: 12 } },
        gridItem: {
            aspectRatio: { base: "1:1", s: "9:16" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1", s: "9:16" },
            sizes: ["100vw", "66vw"],
        },
    },
    {
        grid: { colSpan: { base: 6, s: 4 }, rowSpan: { base: 1, s: 6 } },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["100vw", "33vw"],
        },
    },
    {
        grid: { colSpan: { base: 6, s: 4 }, rowSpan: { base: 1, s: 6 } },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["100vw", "33vw"],
        },
    },
];

const gridWith3Items = [
    {
        grid: { colSpan: { base: 12, s: 4 }, rowSpan: { base: 1, s: 4 } },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["100vw", "100vw", "33vw"],
        },
    },
    {
        grid: { colSpan: { base: 12, s: 8 }, rowSpan: { base: 1, s: 12 } },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["100vw", "100vw", "66vw"],
        },
    },
    {
        grid: { colSpan: { base: 12, s: 4 }, rowSpan: { base: 1, s: 4 } },
        gridItem: {
            aspectRatio: { base: "1:1" },
        },
        gridItemAsset: {
            aspectRatio: { base: "1:1" },
            sizes: ["100vw", "100vw", "33vw"],
        },
    },
];

const getGalleryLayoutConfig = (itemsCount: number): Array<GalleryLayoutConfig> => {
    switch (itemsCount) {
        case 5:
            return gridWith5Items;
        case 4:
            return gridWith4Items;
        case 3:
        default:
            return gridWith3Items;
    }
};

export { getGalleryLayoutConfig };
